module.exports = ".title-mensaje{\r\n    font-size: 16px;\r\n    color: #555;\r\n}\r\n.icono-mensaje{\r\n    font-size: 40px;\r\n    display: block;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-mensaje-usuario/modal-mensaje-usuario.component.css
// module id = ./src/app/shared/modal/modal-mensaje-usuario/modal-mensaje-usuario.component.css
// module chunks = main